import React from "react";
import {
  Text,
  Avatar,
  HStack,
  Image,
  Circle,
  Icon,
  Flex,
  Stack,
} from "@chakra-ui/react";
import {
  textSecondary,
  backgroundLight,
  textPrimary,
  white,
} from "../../../../utils/colors";
import dayjs from "dayjs";
// import MoreButton from "../../../../components/buttons/MoreButton";
import { TbCake } from "react-icons/tb";
// import blank from "../../../../assets/icons/blank.svg";
import StatusBadge from "../../../../components/badges/StatusBadge";
// import StatusButtonNew from "../../../../components/buttons/StatusButtonNew";
import StatusButtonNewLite from "../../../../components/buttons/StatusButtonNewLite";
import MoreButtonLite from "../../../../components/buttons/MoreButtonLite";

export const columnsMobile = (translate, isMobile) => {
  const allColumns = [
    {
      Header: () => (
        <Flex h="100%" w="100%">
          <Flex align="center" cursor="pointer">
            <Text textAlign="left">{translate("patient.columnID")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "patientID",
      width: 100,
      disableSortBy: true,
      Cell: ({ row }) => {
        const { patientID } = row.original;

        return (
          <Text
            textAlign="left"
            overflow="hidden"
            whiteSpace="nowrap"
            fontSize="xs"
            color={textSecondary}
            fontWeight="500"
          >
            {patientID}
          </Text>
        );
      },
    },

    {
      Header: () => (
        <Flex h="100%" w="100%">
          <Flex align="center" cursor="pointer">
            <Text>{translate("patient.columnName")}</Text>
          </Flex>
        </Flex>
      ),
      disableSortBy: true,
      width: 100,
      accessor: "lastName",
      Cell: ({ row }) => {
        const { firstName, lastName, image, patientID, status } = row.original;
        const name = `${lastName} ${firstName}`;

        return (
          <HStack gap={2}>
            {image ? (
              <Image
                size="sm"
                src={image}
                alt={name}
                borderRadius="10rem"
                objectFit="cover"
              />
            ) : (
              <>
                {!isMobile && (
                  <Avatar
                    h={["2.5rem", "2rem", "2rem"]}
                    w={["2.5rem", "2rem", "2rem"]}
                    name={name}
                    // bg="#dceeff"
                    // color="#3a74a9"
                    bg={textPrimary}
                    color={white}
                  />
                )}
              </>
            )}

            <Stack gap={0}>
              <Text
                fontSize="md"
                color={textPrimary}
                fontWeight="600"
                isTruncated // This will add ellipsis
                maxW="200px"
              >
                {lastName}
                <Text as="span" fontWeight="400" ml={1}>
                  {firstName}
                </Text>
              </Text>
              {/* {isMobile && (
                <Flex align="baseline" m="0.25rem 0 0">
                  <StatusBadge isSmall status={status} options="user" />
                  <Text
                    fontSize="xs"
                    color={textSecondary}
                    fontWeight="500"
                    ml={2}
                  >
                    {patientID}
                  </Text>
                </Flex>
              )} */}
            </Stack>
          </HStack>
        );
      },
    },

    // {
    //   Header: () => (
    //     <Flex h="100%" w="100%">
    //       <Flex align="center" cursor="pointer">
    //         <Text>{translate("patient.columnBirthdate")}</Text>
    //       </Flex>
    //     </Flex>
    //   ),
    //   accessor: "age",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const { birthDate } = row.original;

    //     if (!birthDate)
    //       return (
    //         <Text fontSize="sm" fontWeight="500" color={textSecondary}>
    //           -
    //         </Text>
    //       );

    //     // Calculate the precise age considering months and days
    //     const today = dayjs();
    //     const birthDay = dayjs(birthDate);
    //     let age = today.year() - birthDay.year();

    //     // Adjust if the birthday hasn’t occurred yet this year
    //     if (
    //       today.month() < birthDay.month() ||
    //       (today.month() === birthDay.month() && today.date() < birthDay.date())
    //     ) {
    //       age--;
    //     }

    //     return (
    //       <Flex align="center" w="100%">
    //         <Circle
    //           size="18px"
    //           bg={backgroundLight}
    //           color={textSecondary}
    //           mr={1}
    //         >
    //           <Icon as={TbCake} fontSize="sm" />
    //         </Circle>
    //         <Text
    //           fontSize="sm"
    //           color={textSecondary}
    //           fontWeight="500"
    //           whiteSpace="nowrap"
    //         >
    //           {age} {translate("patient.yearsOld")}
    //           <Text as="span" fontWeight="400" mx={2}>
    //             |
    //           </Text>
    //           {dayjs(birthDate).format("YYYY")}
    //         </Text>
    //       </Flex>
    //     );
    //   },
    // },

    // {
    //   Header: () => (
    //     <Flex h="100%" w="100%">
    //       <Flex align="center" cursor="pointer">
    //         <Text>{translate("patient.columnPhone")}</Text>
    //       </Flex>
    //     </Flex>
    //   ),
    //   accessor: "phone",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const { phone } = row.original;

    //     return (
    //       <>
    //         <Text
    //           textAlign="left"
    //           fontSize="sm"
    //           fontWeight="500"
    //           color={textSecondary}
    //           w="100%"
    //         >
    //           {phone ? phone : "-"}
    //         </Text>
    //       </>
    //     );
    //   },
    // },
    // {
    //   Header: () => (
    //     <Flex h="100%">
    //       <Flex align="center" cursor="pointer">
    //         <Text>{translate("patient.columnState")}</Text>
    //       </Flex>
    //     </Flex>
    //   ),
    //   accessor: "state",
    //   disableSortBy: true,
    //   Cell: ({ row }) => {
    //     const rowOriginal = row.original;

    //     const state =
    //       rowOriginal.address && rowOriginal.address.length > 0
    //         ? rowOriginal.address[0].state
    //         : null;

    //     return (
    //       <>
    //         <Text
    //           fontSize="sm"
    //           fontWeight="500"
    //           textAlign="left"
    //           color={textSecondary}
    //           maxW="120px"
    //           isTruncated
    //         >
    //           {state ? state : "-"}
    //         </Text>
    //       </>
    //     );
    //   },
    // },
    {
      Header: () => (
        <Flex>
          <Flex align="center" cursor="pointer" justify="flex-end">
            <Text>{translate("patient.columnStatus")}</Text>
          </Flex>
        </Flex>
      ),
      accessor: "status",
      disableSortBy: true,
      preventRowClick: true,
      Cell: ({ row }) => {
        const { status, _id } = row.original;

        return (
          <HStack gap={0} justify="flex-end">
            <StatusButtonNewLite
              size="md"
              p={["0 1rem", "0 4.5rem"]}
              currentStatus={status}
              options="patient"
            />
            {/* <MoreButtonLite
              id={_id}
              deleteHandler={true}
              setShowDeleteConfirmation={() => {
                setUserId(_id); // Set the user ID for deletion
                setShowDeleteConfirmation(true); // Open confirmation modal
                setPatientName(
                  row.original.lastName + " " + row.original.firstName
                );
              }}
            /> */}
          </HStack>
        );
      },
    },
  ];

  return allColumns;
};
